import gql from "graphql-tag";

export const T_ACCOUNT_CHARTS = gql`
    query tAccountCharts2($filter: TAccountChart2FilterInput) {
        tAccountCharts2(filter: $filter) {
            _id
            name
            version
            client {
                _id
                name
            }
            locked
            createTimestamp
            createUserInfo {
                _id
                name
            }
            updateTimestamp
            updateUserInfo {
                _id
                name
            }
        }
        clients: parties(filter: { typeIn: [Fund, Client] }) {
            _id
            name
        }
    }
`;

export const T_ACCOUNT_CHART = gql`
    query tAccountChart2($id: GraphQLObjectId!) {
        tAccountCharts2(filter: { idIn: [$id] }) {
            _id
            name
            version
            clientId
            client {
                _id
                name
            }
            locked
            createTimestamp
            createUserInfo {
                _id
                name
            }
            updateTimestamp
            updateUserInfo {
                _id
                name
            }
            tAccounts {
                number
                type
                description
                group1
                group2
                group3
                group4
                group5
            }
            tAccountMappings {
                name
                selector {
                    instruments
                    currencies
                    modelTypes
                    cicTypes
                }
                values {
                    accountingTransactionType
                    debit
                    credit
                }
            }
        }
        me {
            _id
            roles {
                _id
                assets
                clientIds
                permissionType
            }
        }
    }
`;

export const UPSERT_T_ACCOUNT_CHART = gql`
    mutation upsertTAccountChart2($input: UpsertTAccountChartInput) {
        upsertTAccountChart2(input: $input) {
            _id
            name
            version
            clientId
            locked
            createTimestamp
            createUserId
            createUserInfo {
                _id
                name
            }
            updateTimestamp
            updateUserId
            updateUserInfo {
                _id
                name
            }
            tAccounts {
                number
                type
                description
                group1
                group2
                group3
                group4
                group5
            }
            tAccountMappings {
                name
                selector {
                    instruments
                    currencies
                    modelTypes
                    cicTypes
                }
                values {
                    accountingTransactionType
                    debit
                    credit
                }
            }
        }
    }
`;

export const T_ACCOUNT_MAPPING_INSTRUMENTS = gql`
    query tAccountMappingInstruments {
        instruments {
            _id
            name
        }
    }
`;
